import { mapState } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { MountingPortal } from '../../../lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { GlDrawer } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import DiffsFileTree from '../../../diffs/components/diffs_file_tree.vue?vue3';
import { useDiffsList } from '../../stores/diffs_list.js?vue3';
import { useFileBrowser } from '../../../diffs/stores/file_browser.js?vue3';
import { useDiffsView } from '../../stores/diffs_view.js?vue3';
import { DRAWER_Z_INDEX } from '~/lib/utils/constants';
export default {
    name: 'FileBrowserDrawer',
    DRAWER_Z_INDEX,
    components: {
        MountingPortal,
        DiffsFileTree,
        GlDrawer
    },
    props: {
        groupBlobsListItems: {
            type: Boolean,
            required: false,
            default: true
        },
        linkedFilePath: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'click-file'
    ],
    data () {
        return {
            openedOnce: false
        };
    },
    computed: {
        ...mapState(useDiffsView, [
            'totalFilesCount',
            'currentDiffFileHash'
        ]),
        ...mapState(useDiffsList, [
            'loadedFiles'
        ]),
        ...mapState(useFileBrowser, [
            'fileBrowserDrawerVisible'
        ])
    },
    watch: {
        fileBrowserDrawerVisible () {
            this.openedOnce = true;
        }
    },
    beforeDestroy () {
        useFileBrowser().setFileBrowserDrawerVisibility(false);
    },
    methods: {
        clickFile (file) {
            this.$emit('click-file', file);
            this.close();
        },
        selectFile (file) {
            useDiffsView().setCurrentFile(file.fileHash);
            this.close();
        },
        toggleFolder (path) {
            useFileBrowser().toggleTreeOpen(path);
        },
        close () {
            useFileBrowser().setFileBrowserDrawerVisibility(false);
        }
    }
};
